module.exports = "<router-outlet></router-outlet>\n\n<div class=\"loader\" *ngIf=\"_globalService.global_loader\">\n  <p-progressSpinner [style]=\"{width: '60px', height: '60px'}\"></p-progressSpinner>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main